import { themes as o } from "../colors/themes/themes.js";
import { themes as s } from "../icons/themes/themes.js";
const r = [
  "free",
  "premium",
  "plurall",
  "goStudentLearning"
], i = r.reduce((t, e) => {
  const m = {
    colors: o[e],
    icons: s[e]
  };
  return t[e] = m, t;
}, {});
export {
  i as themes
};
